// extracted by mini-css-extract-plugin
module.exports = {"container":"Desktop_container__3uiEq","logo":"Desktop_logo__eAHO2"};